module.exports = __webpack_public_path__ + "static/media/3.aa66ca19.jpeg";